import { RequestHeaders, tenant } from "@certa/network";
import { UserStorage } from "@certa/common/utils/userStorage";

export const getCommonHeaders = (config: { userName: string }) => {
  const user = UserStorage.getUser();

  return {
    ...RequestHeaders.common,
    "X-DTS-USERNAME": config.userName,
    "X-DTS-EMAIL": user?.email ?? ""
  };
};

export const getDesignAIv3CommonHeaders = () => {
  return {
    "Content-Type": "application/json",
    "X-TENANT": tenant
  };
};

export const getDesignAIv3FormDataHeaders = () => {
  return {
    "X-TENANT": tenant
  };
};
